import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowDown } from '@fortawesome/free-solid-svg-icons';

import resumePdf from '../../assets/Darshan_Lal_CV.pdf';
import { siteConfig } from '../../config/site';
import Footer from '../Footer/Footer';

import '../../styles/Layout/SubPageLayout.scss';

/** Wraps standalone pages (e.g. `/about/experience`) with a way back home and the footer. */
export default function SubPageLayout({ children, backTo = '/#about' }) {
  return (
    <>
      <nav className="subpage__nav" aria-label="Page">
        <div className="subpage__bar">
          <Link to={backTo} className="subpage__back">
            <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" /> Back to portfolio
          </Link>
          <a className="btn btn--primary btn--sm" href={resumePdf} download={siteConfig.resumeDownloadFilename}>
            Résumé <FontAwesomeIcon icon={faArrowDown} aria-hidden="true" />
          </a>
        </div>
      </nav>
      <main id="main-content" tabIndex={-1} className="subpage__main">
        {children}
      </main>
      <Footer />
    </>
  );
}
